// Flag-gated entry point for Hypothesis Intake. Renders nothing unless the
// Validation Engine flag is on, so it is a no-op for everyone by default.
// On completion it stashes the card for the backtest step to pick up.
// (DB persistence + audit are wired in commit G.)

import { useState } from 'react';
import { Lightbulb } from 'lucide-react';
import { useValidationEngineGate } from '../../config/useValidationEngineGate';
import HypothesisIntakeModal from './HypothesisIntakeModal';
import { setCurrentHypothesis } from '../../engine/validation/hypothesisSession';
import { recordHypothesisCreated, recordLaneEvent } from '../../services/validationService';

export default function HypothesisIntakeLauncher() {
  const gate = useValidationEngineGate();
  const [open, setOpen] = useState(false);
  const [done, setDone] = useState(false);

  if (!gate.enabled) return null;

  return (
    <div className="mt-3">
      <button
        type="button"
        onClick={() => setOpen(true)}
        className="inline-flex items-center gap-1.5 px-3 py-1.5 text-sm font-medium rounded border border-fuchsia-300 text-fuchsia-700 hover:bg-fuchsia-50"
      >
        <Lightbulb className="w-3.5 h-3.5" />
        Start with a hypothesis
      </button>
      {done && (
        <div className="text-[11px] text-emerald-700 mt-1">
          Hypothesis saved — build your strategy, then run a backtest to get a Reality Check.
        </div>
      )}
      {open && (
        <HypothesisIntakeModal
          onClose={() => setOpen(false)}
          onAuditEvent={(type, payload) => { void recordLaneEvent(type, payload); }}
          onComplete={(card) => {
            setCurrentHypothesis(card);
            void recordHypothesisCreated(card);
            setDone(true);
            setOpen(false);
          }}
        />
      )}
    </div>
  );
}
